// --- Conversion degrés → radians ---
export function deg_rad(deg) {
  return deg * (Math.PI / 180);
}

// --- Distance entre 2 points GPS (formule Haversine) ---
export function getDistance(lat1, lon1, lat2, lon2) {
  var R = 6371; // Rayon terrestre en km
  var dLat = deg_rad(lat2 - lat1);
  var dLon = deg_rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg_rad(lat1)) * Math.cos(deg_rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// --- Trouve les adresses les plus proches d'une ville saisie ---
export function findClosestAddresses(cityName, data) {
  const cityKey = cityName.toLowerCase();
  const cityRef = data[cityKey];  // On récupère directement l'objet

  if (!cityRef) return [];        // Si la ville n'existe pas -> on retourne []

  // On prend toutes les adresses (une par ville)
  const allAddresses = Object.values(data);

  // On calcule la distance entre la ville choisie et chaque adresse
  const sorted = allAddresses
    .map((addr) => ({
      ...addr,
      distance: getDistance(cityRef.lat, cityRef.lon, addr.lat, addr.lon)
    }))
    .sort((a, b) => a.distance - b.distance);

  return sorted.slice(0, 3); // On retourne seulement les 3 plus proches
}